const initialState = {
  loading: false,
  userRole: "",
  error: "",
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "LOGIN_SUCCEES":
      return {
        loading: false,
        userRole: action.payload,
        error: "",
      };
    case "LOGIN_FAILED":
      return {
        loading: false,
        userRole: "",
        error: action.payload,
      };
    default:
      return state;
  }
};

export default loginReducer;
